import React from 'react'
import { cloneElementWithClassName } from './cloneElementWithClassName'

export function cloneChildrenWithClassName(children: React.ReactNode, className: string) {
  return React.Children.map(children, (child) => {
    return React.isValidElement(child) && cloneElementWithClassName(child, className)
  })
}
